<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 align-self-center>
        <video-background
          :src="require('./../../assets/videos/finalVideo.mp4')"
          style="max-height: 90vh; height: 100vh"
          class="align-text-center"
        >
        <v-layout wrap justify-center>
          <v-flex xs12 lg6 px-sm-16 :style="$vuetify.breakpoint.name=='xs'?'padding-top:50%':'padding-top:15%'" align-self-center>
            <!-- <span :class="$vuetify.breakpoint.name=='xs'?'subxs':'subtitle'" style="color: white">
            Build products, practice skills, learn technologies &
            grow your network.
            </span> -->
          </v-flex>
        </v-layout>
          
        </video-background>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      vdo: ["./../../assets/videos/tigermovie.mp4"],
    };
  },
};
</script>
